/**
 * Contagem dos totais do Início (movimento, 23/10/2026): os números contam de 0 até os da pessoa
 * uma vez por sessão; ao voltar ao Início, já estão lá. A marca vive no módulo (a sessão é a aba).
 */
let contados = false;

/** Os totais já contaram nesta sessão. */
export function totaisJaContados(): boolean {
  return contados;
}

/** Marca a contagem como feita (quando as listas chegam, com os números finais). */
export function marcarTotaisContados(): void {
  contados = true;
}

/** Volta ao começo da sessão (para os testes). */
export function zerarTotaisContados(): void {
  contados = false;
}
